import { array, defineAction, number, object, string } from '~/prix'
import fetchAvailableQuestionnaireAction from './questionnaireFetchAvailable.action.json' with { type: 'json' }
import { z } from 'zod'
import { answerObject } from '../questionnaireObject'

const fetchAvailableQuestionnaireDefinition = defineAction({
  ...fetchAvailableQuestionnaireAction,
  input: z.object({
    citizenId: z.string().describe('Id do cidadão'),
    professionalId: z.string().describe('Id da profissional que aplicou o questionário'),
    familyId: z.string().describe('Id da familia que respondeu o questionário'),
    answers: z.array(answerObject),
  }),
  output: z.object({
    answersSent: z.array(answerObject).describe('Respostas Enviadas'),
    answerSheetId: z.number().describe('ID da folha de respostas'),
  }),
})

export default fetchAvailableQuestionnaireDefinition
